import { render, staticRenderFns } from "./DetailedSimulatorPopUp.vue?vue&type=template&id=372d322c&scoped=true&"
import script from "./DetailedSimulatorPopUp.vue?vue&type=script&lang=js&"
export * from "./DetailedSimulatorPopUp.vue?vue&type=script&lang=js&"
import style0 from "./DetailedSimulatorPopUp.vue?vue&type=style&index=0&id=372d322c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d322c",
  null
  
)

export default component.exports